const examPlan = () => import('@/pages/examPlan/index.vue');
const examSeasonPreview = () => import('@/pages/examPlan/examSeasonPreview.vue');

export default [
  {
    path: '/examPlanIndex',
    name: 'examPlan',
    component: examPlan,
  },
  {
    path: '/examSeasonPreview',
    name: 'examSeasonPreview',
    component: examSeasonPreview,
  },
];
